module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.opened ? "v_dropdown-multiple opened" : "v_dropdown-multiple"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.activeOpts),
      expression: "activeOpts"
    }],
    attrs: {
      "type": "text",
      "readonly": "",
      "placeholder": _vm.placeholder,
      "title": _vm.activeOpts
    },
    domProps: {
      "value": (_vm.activeOpts)
    },
    on: {
      "click": _vm.open,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.activeOpts = $event.target.value
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "focus-bg"
  }), _vm._v(" "), _c('div', {
    staticClass: "wtf",
    on: {
      "click": _vm.wtf
    }
  }), _vm._v(" "), _c('div', {
    class: _vm.opened ? "options active" : "options"
  }, [_c('div', {
    staticClass: "overflow"
  }, [(_vm.options.length) ? _vm._l((_vm.options), function(opt) {
    return _c('div', {
      class: _vm.activeClass(opt.text) ? "opt active" : "opt",
      on: {
        "click": function($event) {
          _vm.select(opt.text, opt.value, _vm.activeClass(opt.text))
        }
      }
    }, [_vm._v("\n\t\t\t\t\t" + _vm._s(opt.text) + "\n\t\t\t\t")])
  }) : [_c('div', {
    staticClass: "null"
  })]], 2)])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1f36870d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/includes/components/forms/elements/dropdown-multiple.vue
// module id = 244
// module chunks = 36